import { render, staticRenderFns } from "./keHuDetails.vue?vue&type=template&id=509c570a&scoped=true&"
import script from "./keHuDetails.vue?vue&type=script&lang=js&"
export * from "./keHuDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c570a",
  null
  
)

export default component.exports